// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.notification {\n  z-index: 999999;\n  width: 500px;\n  max-width: 90vw;\n  margin: auto 12px 12px auto;\n}\n.notifications {\n  z-index: 999999;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  position: fixed;\n  bottom: 12px;\n  max-height: 30vh;\n}", ""]);
// Exports
module.exports = exports;
